
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/util'

export default defineComponent({
  props: {
    toggleModalVisible: { type: Function, required: false, default: undefined },
    location: { type: String, required: false, default: undefined },
    duration: { type: String, required: false, default: undefined },
    price: { type: String, required: false, default: undefined },
    isAvailable: { type: Boolean, required: false, default: true },
    courseMaterial: { type: Boolean, required: false, default: false },
  },
  setup() {
    const { t_ } = setupTranslationPrefixer('EducationProductionPageInfoData')

    return { t_ }
  },
})
